import Vue from 'vue';
import VueRouter from 'vue-router';

import store from './store';

import Login from './auth/Login';
import Signup from './auth/Signup';
import ForgotPassword from './auth/ForgotPassword';
import CollectorsClubRegistration from './auth/CollectorsClubRegistration';
import Account from './auth/Account';
import PrivacyPolicy from './auth/PrivacyPolicy';
import TermsOfUse from './auth/TermsOfUse';

import DashboardView from './dashboard/DashboardView';

import IndexListView from './index/IndexListView';
import PlayerListView from './index/PlayerListView';
import IndexView from './index/IndexView';
import CustomIndexView from './index/CustomIndexView';

import PlayerView from './index/PlayerView';

import LadderView from './ladder/LadderView';

import CardView from './cards/CardView';

import ProfileSearchView from './profiles/ProfileSearchView';
import ProfileView from './profiles/ProfileView';

import FeedView from './feed/FeedView';

import CompareView from './compare/CompareView';

import SalesHistoryView from './sales/SalesHistoryView';
import SalesSearchView from './sales/SalesSearchView';

import CollectionView from './collection/CollectionView';

import ShopView from './shop/ShopView';

import Industry from './industry/IndustryView';

import WatchlistView from './watchlist/WatchlistView';

import ShowcaseView from './showcase/ShowcaseView';
import ShowcaseUserView from './showcase/ShowcaseUserView';

import AddCardsView from './admin/AddCardsView';
import ReportsView from './admin/ReportsView';
import EmployeeView from './admin/EmployeeView';
import AuditLogView from './admin/AuditLogView';
import PendingSales from './admin/PendingSales';
import HeadlinesView from './admin/HeadlinesView';
import AdminView from './admin/AdminView';
import UserView from './admin/UserView';
import ApiCustomersView from './admin/ApiCustomersView';
import ApiCustomerView from './admin/ApiCustomerView';

Vue.use(VueRouter);

const routes = [
  {
    path: '*',
    redirect: '/login',
  },
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login',
      preAuth: true,
    },
  },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup,
    meta: {
      title: 'Signup',
      preAuth: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      title: 'Forgot Password',
      preAuth: true,
    },
  },
  {
    path: '/collectorsclub',
    name: 'CollectorsClubRegistration',
    component: CollectorsClubRegistration,
    meta: {
      title: 'Collectors Club Registration',
      preAuth: true,
    },
  },
  {
    path: '/account',
    name: 'Account',
    component: Account,
    meta: {
      title: 'Account',
      scrollTop: true,
      requiresAuth: true,
    },
  },
  {
    path: '/search',
    name: 'SalesSearch',
    component: SalesSearchView,
    meta: {
      title: 'Search',
      public: true,
    },
  },
  {
    path: '/industry',
    name: 'Industry',
    component: Industry,
    meta: {
      title: 'Industry',
      requiresAuth: true,
      scrollTop: true,
      publicRedirect: '/pro-features/industry',
    },
  },
  {
    path: '/sales-history',
    name: 'SalesHistory',
    component: SalesHistoryView,
    meta: {
      title: 'Sales History',
      requiresAuth: true,
      publicRedirect: '/pro-features/sales-history',
    },
  },
  {
    path: '/showcase',
    name: 'Showcase',
    component: ShowcaseView,
    meta: {
      title: 'Showcase',
      requiresAuth: true,
      publicRedirect: '/showcase',
    },
  },
  {
    path: '/showcase/:id',
    name: 'ShowcaseUser',
    component: ShowcaseUserView,
    meta: {
      title: 'User Showcase',
      requiresAuth: true,
      publicRedirect: '/showcase/{id}',
    },
  },
  {
    path: '/shop',
    name: 'Shop',
    component: ShopView,
    meta: {
      title: 'Shop',
      requiresAuth: true,
      publicRedirect: '/shop',
    },
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: DashboardView,
    meta: {
      title: 'Dashboard',
      requiresAuth: true,
    },
  },
  {
    path: '/indexes',
    name: 'Indexes',
    component: IndexListView,
    meta: {
      title: 'Indexes',
      scrollTop: true,
      requiresAuth: true,
      publicRedirect: '/indexes',
    },
  },
  {
    path: '/players',
    name: 'Players',
    component: PlayerListView,
    meta: {
      title: 'Players',
      scrollTop: true,
      requiresAuth: true,
      publicRedirect: '/players',
    },
  },
  {
    path: '/indexes/:name',
    name: 'Index',
    component: IndexView,
    meta: {
      title: 'Index',
      requiresAuth: true,
      publicRedirect: '/indexes/{name}',
    },
  },
  {
    path: '/players/:name',
    name: 'Player',
    component: PlayerView,
    meta: {
      title: 'Player',
      requiresAuth: true,
      publicRedirect: '/players/{name}',
    },
  },
  {
    path: '/indexes/custom/:name',
    name: 'Custom Index',
    component: CustomIndexView,
    meta: {
      title: 'Custom Index',
      requiresAuth: true,
      publicRedirect: '/indexes',
    },
  },
  {
    path: '/ladder',
    name: 'Ladder',
    component: LadderView,
    meta: {
      title: 'Ladder',
      requiresAuth: true,
      publicRedirect: '/ladder',
    },
  },
  {
    path: '/card/:id',
    name: 'Card',
    component: CardView,
    meta: {
      title: 'Card Details',
      requiresAuth: true,
      scrollTop: true,
      publicRedirect: '/ladder/card/{id}',
    },
  },
  {
    path: '/feed',
    name: 'Feed',
    component: FeedView,
    meta: {
      title: 'Feed',
      requiresAuth: true,
      publicRedirect: '/feed',
    },
  },
  {
    path: '/compare',
    name: 'Compare',
    component: CompareView,
    meta: {
      title: 'Compare',
      requiresAuth: true,
      publicRedirect: '/pro-features/compare',
    },
  },
  {
    path: '/collection',
    name: 'Collection',
    component: CollectionView,
    meta: {
      title: 'Collection',
      requiresAuth: true,
      publicRedirect: '/pro-features/collection',
    },
  },
  {
    path: '/watchlist',
    name: 'Watchlist',
    component: WatchlistView,
    meta: {
      title: 'Watchlist',
      requiresAuth: true,
      publicRedirect: '/pro-features/watchlist',
    },
  },
  {
    path: '/add',
    name: 'AddCards',
    component: AddCardsView,
    meta: {
      title: 'Verify Cards',
      requiresStaff: true,
    },
  },
  {
    path: '/reports',
    name: 'Reports',
    component: ReportsView,
    meta: {
      title: 'Reports',
      requiresStaff: true,
    },
  },
  {
    path: '/employee/:id',
    name: 'Employee',
    component: EmployeeView,
    meta: {
      title: 'Employee',
      requiresStaff: true,
    },
  },
  {
    path: '/audit',
    name: 'AuditLog',
    component: AuditLogView,
    meta: {
      title: 'Audit Log',
      requiresStaff: true,
    },
  },
  {
    path: '/pending-sales',
    name: 'PendingSales',
    component: PendingSales,
    meta: {
      title: 'Pending Sales',
      scrollTop: true,
      requiresStaff: true,
    },
  },
  {
    path: '/headlines',
    name: 'Headlines',
    component: HeadlinesView,
    meta: {
      title: 'Headlines',
      scrollTop: true,
      requiresStaff: true,
    },
  },
  {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: 'Privacy Policy',
      scrollTop: true,
      public: true,
    },
  },
  {
    path: '/tos',
    name: 'TermsOfUse',
    component: TermsOfUse,
    meta: {
      title: 'Terms of Use',
      scrollTop: true,
      public: true,
    },
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminView,
    meta: {
      title: 'Admin',
      requiresStaff: true,
    },
  },
  {
    path: '/user/:id',
    name: 'User',
    component: UserView,
    meta: {
      title: 'User',
      requiresStaff: true,
    },
  },
  {
    path: '/api-customers',
    name: 'ApiCustomers',
    component: ApiCustomersView,
    meta: {
      title: 'API Customers',
      requiresStaff: true,
    },
  },
  {
    path: '/api-customers/:id',
    name: 'ApiCustomer',
    component: ApiCustomerView,
    meta: {
      title: 'API Customer',
      requiresStaff: true,
    },
  },
  {
    path: '/profiles',
    name: 'ProfileSearch',
    component: ProfileSearchView,
    meta: {
      title: 'Profile Search',
      requiresAuth: true,
    },
  },
  {
    path: '/profiles/:profileId',
    name: 'Profile',
    component: ProfileView,
    meta: {
      title: 'Profile',
      requiresAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: import.meta.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.meta.scrollTop) {
      return { x: 0, y: 0 };
    }

    return {};
  },
});

router.beforeEach((to, _, next) => {
  const isUser = Boolean(store.state.user && store.state.user.role === 'user');
  const isAdmin = Boolean(store.state.user && store.state.user.role === 'admin');
  const isStaff = Boolean(store.state.user && store.state.user.role === 'staff');
  const isMember = Boolean(store.state.user && store.state.user.role === 'member');
  const isPayingMember = isMember || isAdmin || isStaff;

  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const requiresStaff = to.matched.some((record) => record.meta.requiresStaff);
  const preAuth = to.matched.some((record) => record.meta.preAuth);

  const blockAuth = requiresAuth && !isPayingMember;
  const blockStaff = requiresStaff && !isAdmin && !isStaff;
  const blockPreAuth = preAuth && isPayingMember;
  const shouldHandlePublicRedirect = (blockAuth || (isUser && to.name !== 'Signup')) && Boolean(to.meta && to.meta.publicRedirect);
  const nearestWithTitle = to.matched.slice().reverse().find((r) => r?.meta?.title);

  document.title = `${nearestWithTitle?.meta?.title} | Card Ladder Pro`;
  document.body.classList.remove('disable-mobile-scroll');

  if (preAuth) {
    document.body.classList.add('pre-auth');
  } else {
    document.body.classList.remove('pre-auth');
  }

  try {
    if (to?.name === 'SalesSearch') {
      next();
    } else if (shouldHandlePublicRedirect) {
      let publicRedirect = to.meta.publicRedirect;

      if (publicRedirect.includes('{')) {
        const routeId = publicRedirect.substring(publicRedirect.lastIndexOf('{') + 1, publicRedirect.lastIndexOf('}'));

        publicRedirect = publicRedirect.replace(`{${routeId}}`, to.params[routeId]);
      }

      window.location.replace(`${import.meta.env.VITE_FREE_DOMAIN}${publicRedirect}`);
    } else if (isUser) {
      if (to.name === 'Signup') {
        next();
      } else {
        next({ path: '/signup', query: { ...to.query } });
      }
    } else if (blockAuth) {
      next({ path: '/login', query: to.query });
    } else if (blockPreAuth || blockStaff) {
      next({ path: '/dashboard', query: to.query });
    } else {
      next();
    }
  } catch (e) {
    // swallow
  }
});

export default router;
